<template>
  <v-container v-if="studentInfo">
    <div v-if="studentInfo">
      <v-row key="1">
        <a @click="$router.back()">
          <v-btn
            class="px-2 ml-1 ma-1"
            color="success"
            min-width="0"
            small
            absolute
            top
            right
          >
            Back To List
          </v-btn>
        </a>
        <v-col cols="12" md="2" lg="2" xl="2" align="center">
          <v-img :src="tots_image" width="120"> </v-img>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">Enquiry Code</div>
              <div
                class="text-button mb-1"
                v-text="studentInfo.enquiryCode ? studentInfo.enquiryCode : '-'"
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">Student Name</div>
              <div
                class="text-button mb-1"
                v-text="
                  studentInfo.studentFirstName +
                  ' ' +
                  studentInfo.studentLastName
                "
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">Franchisee Name</div>
              <div
                class="text-button mb-1"
                v-text="
                  studentInfo.franchisee.companyName
                    ? studentInfo.franchisee.companyName
                    : '-'
                "
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">Academic Year</div>
              <div
                class="text-button mb-1"
                v-text="
                  studentInfo.academicYear.academicYear
                    ? studentInfo.academicYear.academicYear
                    : '-'
                "
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">Class</div>
              <div
                class="text-button mb-1"
                v-text="studentInfo.class ? studentInfo.class : '-'"
              ></div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row key="2">
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Name
              </div>
              <div
                class="text-button mb-1"
                v-text="studentInfo.fatherName ? studentInfo.fatherName : '-'"
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Mobile
              </div>
              <div
                class="text-button mb-1"
                v-text="
                  studentInfo.fatherMobile ? studentInfo.fatherMobile : '-'
                "
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Parent / Guardian Email
              </div>
              <div
                class="text-button mb-1"
                v-text="
                  studentInfo.fatherEmailID ? studentInfo.fatherEmailID : '-'
                "
              ></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">Student Gender</div>
              <div
                v-if="
                  studentInfo.gender === 'Female' ||
                  studentInfo.gender === 'FEMALE'
                "
                class="text-button mb-1"
                v-text="
                  studentInfo &&
                  studentInfo.gender &&
                  studentInfo.gender === 'Female'
                    ? 'Girl'
                    : '-' ||
                      (studentInfo &&
                        studentInfo.gender &&
                        studentInfo.gender === 'FEMALE')
                    ? 'Girl'
                    : '-'
                "
              ></div>
              <div
                v-if="
                  studentInfo.gender === 'Male' || studentInfo.gender === 'MALE'
                "
                class="text-button mb-1"
                v-text="
                  studentInfo &&
                  studentInfo.gender &&
                  studentInfo.gender === 'Male'
                    ? 'Boy'
                    : '-' ||
                      (studentInfo &&
                        studentInfo.gender &&
                        studentInfo.gender === 'MALE')
                    ? 'Boy'
                    : '-'
                "
              ></div>
              <div v-if="studentInfo.gender === null" class="mb-1">-</div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="2" sm="4">
          <div class="d-flex justify-space-between caption">
            <div>
              <div class="grey--text text-subtitle-2 mb-1">
                Section / Division
              </div>
              <div
                class="text-button mb-1"
                v-text="studentInfo.section ? studentInfo.section : 'N/A'"
              ></div>
            </div>
          </div>
        </v-col>
      </v-row>
      <div>
        <v-card-actions class="justify-end">
          <div v-if="isRazorPayAccount">
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <div
                  style="border: 1px #000; margin-left: 3px; height: inherit"
                  v-bind="attrs"
                  v-on="on"
                >
                  <button
                    class="v-btn v-btn--disabled v-btn--has-bg theme--light v-size--default"
                    type="button"
                    :disabled="
                      Number(totalamountDueTillDate).toFixed(2) <= 0.0 &&
                      Number(totalamountNonDueTillDate).toFixed(2) <= 0.0
                    "
                    small
                    depressed
                    color="primary"
                    @click.prevent="sendServicePlanPaymentLink()"
                  >
                    Send Service Plan Payment link
                  </button>
                </div>
              </template>
              <span>You have to open Razorpay account for online payment.</span>
            </v-tooltip>
          </div>
          <div v-else style="border: 1px #000; margin: 3px">
            <v-btn
              :disabled="
                Number(totalamountDueTillDate).toFixed(2) <= 0.0 &&
                Number(totalamountNonDueTillDate).toFixed(2) <= 0.0
              "
              small
              depressed
              color="primary"
              @click.prevent="sendServicePlanPaymentLink()"
              style="height: 35px"
            >
              Send Service Plan Payment link
            </v-btn>
          </div>
          <v-btn
            :disabled="
              Number(totalamountDueTillDate).toFixed(2) <= 0.0 &&
              Number(totalamountNonDueTillDate).toFixed(2) <= 0.0
            "
            @click="sendServicePlanPaymentOffline(true)"
            depressed
            small
            color="success"
            style="margin-left: 3px; height: 35px"
          >
            Offline Payment
          </v-btn>
        </v-card-actions>
      </div>
      <v-row key="3">
        <v-col cols="12">
          <template>
            <v-toolbar
              flat
              color="warning lighten-3"
              class="d-flex justify-center"
            >
              <v-toolbar-title>Fee Structure (In Installments)</v-toolbar-title>
            </v-toolbar>
            <v-row>
              <v-col cols="12" lg="12" sm="12">
                <v-data-table
                  :headers="headers"
                  :items="feeTypeGroup"
                  :single-expand="true"
                  show-expand
                  hide-default-footer
                  class="elevation-1"
                  item-key="feeTypeName"
                >
                  <template v-slot:top>
                    <v-toolbar flat class="d-flex justify-center">
                      <v-toolbar-title
                        >Franchisee Dues and Payments from
                        students</v-toolbar-title
                      >
                    </v-toolbar>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pb-4 pt-4">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">Installment Name</th>

                              <th class="text-center">Gross Amount</th>
                              <!-- <th class="text-center">
                                Concession Remark
                              </th> -->
                              <th class="text-center">Concession Amount</th>
                              <th class="text-center">Net Amount</th>

                              <th class="text-center" v-if="isGST && !isIGST">
                                CGST Amount
                              </th>

                              <th class="text-center" v-if="isGST && !isIGST">
                                SGST Amount
                              </th>

                              <th class="text-center" v-if="isGST && isIGST">
                                IGST Amount
                              </th>

                              <th class="text-center">Amount Paid Till Date</th>

                              <th class="text-center">Net Amount Due</th>

                              <th class="text-center">Net Amount Not Due</th>
                              <th class="text-center">Due Date</th>
                              <th class="text-center">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="element in item.installments"
                              :key="element.id"
                            >
                              <td align="center" justify="center">
                                {{ element.name }}
                              </td>
                              <td align="center" justify="center">
                                {{ Number(element.amount).toFixed(2) }}
                              </td>
                              <!-- <td align="center" justify="center">{{ element.assignFeeType.concessionRemark }}</td> -->
                              <td align="center" justify="center">
                                {{
                                  Number(element.amountConcession).toFixed(2)
                                }}
                              </td>
                              <td align="center" justify="center">
                                {{ Number(element.netAmount).toFixed(2) }}
                              </td>
                              <td
                                align="center"
                                justify="center"
                                v-if="isGST && !isIGST"
                              >
                                {{ Number(element.cGSTAmt).toFixed(2) }}
                              </td>
                              <td
                                align="center"
                                justify="center"
                                v-if="isGST && !isIGST"
                              >
                                {{ Number(element.sGSTAmt).toFixed(2) }}
                              </td>
                              <td
                                align="center"
                                justify="center"
                                v-if="isGST && isIGST"
                              >
                                {{ Number(element.iGSTAmt).toFixed(2) }}
                              </td>

                              <td align="center" justify="center">
                                {{ Number(element.amountPaid).toFixed(2) }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  Number(element.amountDueTillDate).toFixed(2)
                                }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  Number(element.amountNonDueTillDate).toFixed(
                                    2
                                  )
                                }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  new Date(element.dueDate).toLocaleDateString()
                                }}
                              </td>
                              <td>
                                <v-btn
                                  v-if="
                                    isWrite &&
                                    modules.EditConcessionAmount &&
                                    element.showConcessionBtn
                                  "
                                  title="Manual Concession"
                                  class="px-2 ml-1 ma-1"
                                  color="info"
                                  min-width="0"
                                  small
                                  @click="editConcession(element)"
                                >
                                  Concession
                                </v-btn>
                                <span v-if="isWrite && modules.UnAssignFeePlan">
                                  <v-btn
                                    v-if="element.isActive"
                                    title="Un-Assigned"
                                    class="px-2 ml-1 ma-1"
                                    color="error"
                                    min-width="0"
                                    small
                                    @click="activeInactive(element.id)"
                                  >
                                    Un-Assigned
                                  </v-btn>
                                  <v-btn
                                    v-else
                                    title="Assigned"
                                    class="px-2 ml-1 ma-1"
                                    color="success"
                                    min-width="0"
                                    small
                                    @click="activeInactive(element.id)"
                                  >
                                    Assigned
                                  </v-btn>
                                </span>
                                <span v-if="isWrite && modules.UnAssignFeePlan">
                                  <v-btn
                                    v-if="Number(element.amountPaid) > 0"
                                    title="Refund"
                                    class="px-2 ml-1 ma-1"
                                    color="primary"
                                    min-width="0"
                                    small
                                    @click="
                                      toggleModal(
                                        element.id,
                                        Number(element.amountPaid)
                                      )
                                    "
                                  >
                                    Refund
                                  </v-btn>
                                </span>
                                <v-btn
                                  v-if="isWrite && modules.UnAssignFeePlan"
                                  title="Refund Logs"
                                  class="px-2 ml-1 ma-1"
                                  color="warning"
                                  min-width="0"
                                  small
                                  @click="openRefundLogModal(element)"
                                >
                                  Refund Logs
                                </v-btn>
                                <v-btn
                                  title="Concession Logs"
                                  class="px-2 ml-1 ma-1"
                                  color="warning"
                                  min-width="0"
                                  small
                                  @click="
                                    openLogModal(
                                      element.assignFeeInstallmentLogs
                                    )
                                  "
                                >
                                  Concession Logs
                                </v-btn>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </td>
                  </template>
                  <template v-slot:body.append>
                    <tr>
                      <th class="text-center text-subtitle-2">Totals</th>
                      <th class="text-center text-subtitle-2">
                        {{ totalAmount.toFixed(2) }}
                      </th>
                      <!-- <th class="text-center text-subtitle-2">Remark</th> -->
                      <th class="text-center text-subtitle-2">
                        {{ totalConcession.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ totalnetAmount.toFixed(2) }}
                      </th>
                      <th
                        class="text-center text-subtitle-2"
                        v-if="isGST && isIGST"
                      >
                        {{ totalIGST.toFixed(2) }}
                      </th>
                      <th
                        class="text-center text-subtitle-2"
                        v-if="isGST && !isIGST"
                      >
                        {{ totalCGST.toFixed(2) }}
                      </th>
                      <th
                        class="text-center text-subtitle-2"
                        v-if="isGST && !isIGST"
                      >
                        {{ totalSGST.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ Number(totalAmountToPaid).toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ Number(totalamountDueTillDate).toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ Number(totalamountNonDueTillDate).toFixed(2) }}
                      </th>
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="12" sm="12">
                <v-data-table
                  :headers="headers1"
                  :items="feeTypeGroup"
                  :single-expand="true"
                  show-expand
                  hide-default-footer
                  class="elevation-1"
                  item-key="feeTypeName"
                >
                  <template v-slot:top>
                    <v-toolbar flat class="d-flex justify-center">
                      <v-toolbar-title
                        >Franchisee Payments to Brainbees Paid and Due
                      </v-toolbar-title>
                    </v-toolbar>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="pb-4 pt-4">
                      <v-simple-table>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">Installment Name</th>
                              <th class="text-center">Gross Royalty</th>
                              <th class="text-center">Discount/concession</th>
                              <th class="text-center">
                                Gross Royalty Due(INR)
                              </th>

                              <th class="text-center" v-if="!isIGST">
                                Royalty CGST Amount
                              </th>

                              <th class="text-center" v-if="!isIGST">
                                Royalty SGST Amount
                              </th>

                              <th class="text-center" v-if="isIGST">
                                Royalty IGST Amount
                              </th>
                              <th class="text-center">Royalty TDS Amount</th>
                              <th class="text-center">Net Amount to Pay</th>
                              <th class="text-center">
                                Actual Payment till Date
                              </th>

                              <!-- <th class="text-center">
                                Kit Amount
                              </th> -->
                              <th class="text-center">Royalty Due Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="element in item.installments"
                              :key="element.id"
                            >
                              <td align="center" justify="center">
                                {{ element.name }}
                              </td>

                              <td align="center" justify="center">
                                {{ Number(element.amountRoyalty).toFixed(2) }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  Number(
                                    element.amountRoyaltyConcession
                                  ).toFixed(2)
                                }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  Number(element.netRoyaltyAmount).toFixed(2)
                                }}
                              </td>
                              <td
                                align="center"
                                justify="center"
                                v-if="!isIGST"
                              >
                                {{ Number(element.cGSTAmtRoyalty).toFixed(2) }}
                              </td>
                              <td
                                align="center"
                                justify="center"
                                v-if="!isIGST"
                              >
                                {{ Number(element.sGSTAmtRoyalty).toFixed(2) }}
                              </td>
                              <td align="center" justify="center" v-if="isIGST">
                                {{ Number(element.iGSTAmtRoyalty).toFixed(2) }}
                              </td>
                              <td align="center" justify="center">
                                {{ Number(element.TDSAmtRoyalty).toFixed(2) }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  Number(element.payableAmtRoyalty).toFixed(2)
                                }}
                              </td>
                              <td align="center" justify="center">
                                {{
                                  Number(
                                    element.amountRoyaltyTotalPaid
                                  ).toFixed(2)
                                }}
                              </td>
                              <!-- <td align="center" justify="center">{{ Number(element.otherCollection).toFixed(2) }}</td> -->
                              <td align="center" justify="center">
                                {{
                                  element.dueDateRoyalty
                                    ? new Date(
                                        element.dueDateRoyalty
                                      ).toLocaleDateString()
                                    : '-'
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </td>
                  </template>
                  <template v-slot:body.append>
                    <tr>
                      <th class="text-center text-subtitle-2">Totals</th>

                      <th class="text-center text-subtitle-2">
                        {{ totalAmountRoyalty.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ totalConcessionRoyalty.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ totalRoyaltynetAmount.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2" v-if="isIGST">
                        {{ totalIGSTRoyalty.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2" v-if="!isIGST">
                        {{ totalCGSTRoyalty.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2" v-if="!isIGST">
                        {{ totalSGSTRoyalty.toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ Number(totalTDSRoyalty).toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ Number(totalAmountToPayRoyalty).toFixed(2) }}
                      </th>
                      <th class="text-center text-subtitle-2">
                        {{ Number(totalAmountPaidRoyalty).toFixed(2) }}
                      </th>
                      <!-- <th class="text-center text-subtitle-2">{{ Number(totalOtherCollection).toFixed(2) }}</th> -->
                    </tr>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </template>
        </v-col>
        <!-- <v-col cols="12" v-if="feeActiveComponent.status === 'PENDING'">
          <v-row justify="end">
            <v-col cols="12" lg="3" class="d-flex justify-end">
              <v-btn success icon-right="arrow-right-bold" id="rzp-button1" large color="success" @click="approvePlan(true)">
                Approve
              </v-btn>
            </v-col>

            <v-col cols="12" lg="3" class="d-flex justify-end">
              <v-btn success icon-right="arrow-right-bold" id="rzp-button1" large color="red" @click="approvePlan(false)">
                Reject
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-else>
          <v-row justify="end">
            <v-col cols="12" lg="3" class="d-flex justify-end">
              <v-btn success icon-right="arrow-right-bold" id="rzp-button1" large :color="feeActiveComponent.status === 'APPROVED' ? 'success' : 'red'" class="disable-pointer" readonly>
                {{ feeActiveComponent.status }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col> -->
      </v-row>
      <v-row key="4">
        <student-transaction
          :isAllStudentOrderByenquiryID="isAllStudentOrderByenquiryID"
          :enquiryID="enquiryID"
        ></student-transaction>
      </v-row>
    </div>
    <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
      {{ snackbarMsg || 'Welcome' }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      persistent
      v-model="logsModal"
      max-width="700"
      :active="logsModal"
      :on-cancel="
        () => {
          logsModal = false
        }
      "
    >
      <v-card>
        <v-card-text>
          <v-row class="child-flex">
            <v-data-table
              :headers="logHeaders"
              hide-default-footer
              :items="logArray"
              class="elevation-1 mt-10"
            >
              <template v-slot:item.concessionRemark="{ item }">
                <span class="text-capitalize">
                  {{
                    item.concessionRemark ? item.concessionRemark : '--'
                  }}</span
                >
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{
                  item.createdAt
                    ? new Date(item.createdAt).toLocaleString()
                    : '--'
                }}
              </template>
            </v-data-table>
            <v-col cols="12">
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  @click="
                    () => {
                      logsModal = false
                    }
                  "
                  >Close</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      v-model="concessionModal"
      max-width="900"
      :active="concessionModal"
      :on-cancel="
        () => {
          ;(concessionModal = false), clearConcessionData()
        }
      "
    >
      <form @submit.prevent="saveConcession">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Edit Concession</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    concessionModal = false
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12">
                <p class="label">
                  Due Amount: {{ installmentToEdit.amountDue }}
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Installment name"
                  v-model.trim="installmentToEdit.name"
                  disabled
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  label="Concession Amount *"
                  v-model.trim="newConcessionAmt"
                  placeholder="Concession Amount"
                  required
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  label="Concession Remark *"
                  v-model.trim="newConcessionRemark"
                  placeholder="Concession Remark"
                  required
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <label>Due Date</label>
                <custom-date-picker
                  label="Due Date"
                  v-model="installmentToEdit.dueDate"
                  :minFromDate="minStartDate"
                  :maxToDate="maxDate"
                />
              </v-col>

              <v-col cols="12">
                <v-card-actions class="justify-end">
                  <v-btn color="success" type="submit">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <v-dialog persistent v-model="enableModal" max-width="650">
      <form @submit.prevent="RefundFee">
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title> Refund Amount</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="toggleModal, clearAll()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Enter Refund Amount"
                  type="number"
                  @keydown="preventCharacters($event)"
                  required
                  v-model.trim="refundFee"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Enter Refund Remark"
                  required
                  v-model.trim="refundRemark"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="justify-end">
                  <v-btn color="success" type="submit">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </form>
    </v-dialog>
    <!--Refund Logs start-->
    <v-dialog
      persistent
      v-model="refundRemarkLogsModal"
      max-width="700"
      :active="refundRemarkLogsModal"
      :on-cancel="
        () => {
          refundRemarkLogsModal = false
        }
      "
    >
      <v-card>
        <v-card-text>
          <v-row class="child-flex">
            <v-data-table
              :headers="refundRemarkLogsHeaders"
              hide-default-footer
              :items="refundRemarkLogs"
              class="elevation-1 mt-10"
            >
            </v-data-table>
            <v-col cols="12">
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  @click="
                    () => {
                      refundRemarkLogsModal = false
                    }
                  "
                  >Close</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--Refund Logs end-->
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import StudentTransaction from '../Acad/studentTransaction'
// import ThankYou from '../../Fees/payment/thankYou'
// import ErrorPage from '../../Fees/payment/error'
import moment from 'moment'
export default {
  name: 'ServicesPaymentOptions',
  components: { CustomDatePicker, StudentTransaction },
  props: ['enquiryID', 'assignFeeComponentID', 'planID', 'studentAdmissionID'],
  data () {
    return {
      isAllStudentOrderByID: true,
      concessionModal: false,
      modules: {
        EditConcessionAmount: this.checkModuleAccess('EditConcessionAmount'),
        ChangeClassFeePlan: this.checkModuleAccess('ChangeClassFeePlan'),
        UnAssignFeePlan: this.checkModuleAccess('UnAssignFeePlan')
      },
      minStartDate: new Date().toISOString().slice(0, 10),
      maxDate: null,
      newConcessionAmt: 0,
      newConcessionRemark: '',
      installmentToEdit: {},
      isWrite: false,
      logArray: [],
      logsModal: false,
      logHeaders: [
        { text: 'Concession Remark', value: 'concessionRemark' },
        { text: 'Created on', value: 'createdAt' }
      ],
      isAllStudentOrderByenquiryID: true,
      refundFee: 0,
      refundRemark: '',
      enableModal: false,
      disable: true,
      selectedRows: [],
      selecteditem: '',
      dialog: false,
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      headers1: this.getRoyaltyHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,
      gstType: 'IGST',
      isIGST: true,
      isGST: false,
      isConcession: false,
      loadingComponent: null,
      totalAmount: 0,
      totalAmountDue: 0,
      totalConcession: 0,
      totalAmountToPay: 0,
      totalAmountToPaid: 0,
      totalCGST: 0,
      totalSGST: 0,
      totalIGST: 0,
      totalAmountRoyalty: 0,
      totalAmountDueRoyalty: 0,
      totalConcessionRoyalty: 0,
      totalAmountToPayRoyalty: 0,
      totalAmountPaidRoyalty: 0,
      totalOtherCollection: 0,
      totalCGSTRoyalty: 0,
      totalSGSTRoyalty: 0,
      totalIGSTRoyalty: 0,
      totalTDSRoyalty: 0,
      feeActiveComponent: {},
      checkedRows: [],
      isSuccess: false,
      isError: false,
      isSelected: '',
      feeSelected: [],
      feeTypeGroup: [],
      sumArray: [],
      breakUpData: [],
      feeTypeNaming: '',
      studentInfo: null,
      totalamountDueTillDate: 0,
      totalamountNonDueTillDate: 0,
      totalnetAmount: 0,
      refundRemarkLogs: [],
      refundRemarkLogsModal: false,
      refundRemarkLogsHeaders: [
        { text: 'Refund Remark', value: 'remark' },
        { text: 'Refund Amount', value: 'amount' },
        { text: 'Created on', value: 'updatedAt' }
      ],
      isRazorPayAccount: false
    }
  },
  async created () {
    await this.getAllInfo()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.checkFranchiseeRazorpayAccount()
  },
  methods: {
    toggleModal: function (id, amount) {
      console.log(id, 'id', amount, 'amount')
      this.selectedFeeID = id
      this.checkRefundAmount = amount
      this.enableModal = !this.enableModal
    },
    clearAll: function () {
      this.selectedFeeID = ''
      this.checkRefundAmount = 0
      this.refundFee = 0
      this.refundRemark = ''
      this.enableModal = !this.enableModal
    },
    RefundFee: async function () {
      if (Number(this.refundFee) > this.checkRefundAmount) {
        this.errMsg('Refund Amount Must be less than Amount Paid')
        return false
      }
      let formData = {
        id: this.selectedFeeID,
        amount: this.refundFee,
        remark: this.refundRemark
      }
      try {
        await http.post(
          `${constants.API_URL}/api/student/service/installment/refund`,
          formData
        )
        this.clearAll()
        await this.getAllInfo()
        return this.$dialog.info({
          title: 'Success',
          text: 'Refund Successfully Done!'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    openRefundLogModal (item) {
      this.refundRemarkLogs = item.refundRemarkLogs.map((a) => {
        a.updatedAt = moment(a.updatedAt).format('DD-MM-YYYY')
        return a
      })
      this.refundRemarkLogsModal = true
    },
    preventCharacters (e) {
      if (e.key === 'e' || e.key === 'E') {
        e.preventDefault()
      }
    },
    clearConcessionData () {
      this.installmentToEdit = {}
      this.newConcessionAmt = 0
      this.concessionModal = false
      this.newConcessionRemark = ''
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    activeInactive: async function (id) {
      this.$dialog.info({
        title: 'Assign to Me',
        text: 'Do you want to update status?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                await http.get(
                  `${constants.API_URL}/api/installment/update/fee-concession/${id}`
                )
                this.okMsg('Updated Successfully!')
                this.getAllInfo()
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },
    saveConcession: async function () {
      try {
        this.isLoading = true
        let res = await http.put(
          `${constants.API_URL}/api/installment/update/fee-concession/${this.installmentEditID}`,
          {
            concessionAmount: this.newConcessionAmt,
            dueDate: this.installmentToEdit.dueDate,
            concessionRemark: this.newConcessionRemark
          }
        )
        this.okMsg(res.data)
        this.concessionModal = false
        this.clearConcessionData()
        this.getAllInfo()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    editConcession (obj) {
      console.log(obj, 'obj')
      this.concessionModal = true
      this.installmentEditID = obj.id
      this.installmentToEdit = obj
      this.installmentToEdit.dueDate = moment(obj.dueDate).format('YYYY-MM-DD')
    },

    openLogModal (e) {
      console.log(e, 'e')
      this.logArray = e
      this.logsModal = true
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    sendServicePlanPaymentLink: async function () {
      try {
        const formData = {
          enquiryID: this.enquiryID,
          linkGeneratedFor: this.planID,
          type: 'SCHOOL_SERVICE'
        }

        /** * generate service plan online payment link */
        const response = await http.post(
          `${constants.API_URL}/api/service/payment/link`,
          formData
        )
        console.log(response.data, 'response')
        return this.$dialog.info({
          text: `Email is sent to parent for service plan payment !`,
          title: 'Success'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: `${errorMessage}`,
          title: 'Error'
        })
      }
    },
    sendServicePlanPaymentOffline: async function () {
      try {
        const formData = {
          enquiryID: this.enquiryID,
          linkGeneratedFor: this.planID,
          type: 'SCHOOL_SERVICE_OFFLINE',
          mode: 'OFFLINE'
        }

        /** * generate service plan online payment link */
        const response = await http.post(
          `${constants.API_URL}/api/service/payment/link`,
          formData
        )
        console.log(this.planID, 'planIDofofflinepay')
        // console.log(this.enquiryID, 'Enquiryofflinepay')
        let route = this.$router.resolve({
          name: 'PaymentServicePlanOffline',
          params: { planID: this.planID, referenceID: response.data }
        })
        //  console.log(route, 'Routes')
        // let route = this.$router.resolve('/link/to/page'); // This also works.
        window.open(route.href, '_blank')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: `${errorMessage}`,
          title: 'Error'
        })
      }
    },
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    getRoyaltyHeaders () {
      let royaltyHeader = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' }
      ]
      royaltyHeader.push({
        text: 'Gross Royalty (INR)',
        value: 'totalAmountRoyalty',
        align: 'center'
      })

      royaltyHeader.push({
        text: 'Discount/Concession(INR)',
        value: 'totalConcessionRoyalty',
        align: 'center'
      })

      royaltyHeader.push({
        text: 'Gross Royalty Due (INR)',
        value: 'totalRoyaltynetAmount',
        align: 'center'
      })
      if (this.isIGST) {
        royaltyHeader.push({
          text: 'Royalty IGST (INR)',
          value: 'totalIGSTRoyalty',
          align: 'center'
        })
      } else {
        royaltyHeader.push({
          text: 'Royalty CGST (INR)',
          value: 'totalCGSTRoyalty',
          align: 'center'
        })
        royaltyHeader.push({
          text: 'Royalty SGST (INR)',
          value: 'totalSGSTRoyalty',
          align: 'center'
        })
      }
      royaltyHeader.push({
        text: 'Royalty TDS (INR)',
        value: 'totalTDSAmtRoyalty',
        align: 'center'
      })

      royaltyHeader.push({
        text: 'Net Amount to Pay (INR)',
        value: 'totalAmountPayableRoyalty',
        align: 'center'
      })
      royaltyHeader.push({
        text: 'Actual Payment Till Date (INR)',
        value: 'totalAmountTotalPaidRoyalty',
        align: 'center'
      })

      royaltyHeader.push({ text: '', value: 'data-table-expand' })
      return royaltyHeader
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeTypeName', align: 'center' },
        { text: 'Gross Amount (INR)', value: 'totalAmount', align: 'center' }
      ]

      // if (this.isConcession) {
      // header.push({ text: ' Concession Remark', value: 'concessionRemark', align: 'center' })
      header.push({
        text: 'Less : Concession (INR)',
        value: 'totalConcession',
        align: 'center'
      })
      header.push({
        text: 'Net Amount(INR)',
        value: 'totalnetAmount',
        align: 'center'
      })

      if (this.isGST) {
        if (this.isIGST) {
          header.push({
            text: 'IGST (INR)',
            value: 'totalIGST',
            align: 'center'
          })
        } else {
          header.push({
            text: 'CGST (INR)',
            value: 'totalCGST',
            align: 'center'
          })
          header.push({
            text: 'SGST (INR)',
            value: 'totalSGST',
            align: 'center'
          })
        }
      }

      header.push({
        text: 'Amount Paid till Date(INR)',
        value: 'totalAmountPaid',
        align: 'center'
      })

      header.push({
        text: 'Net Amount Due(INR)',
        value: 'totalamountDueTillDate',
        align: 'center'
      })
      header.push({
        text: 'Net Amount not Due(INR)',
        value: 'totalamountNonDueTillDate',
        align: 'center'
      })

      header.push({ text: '', value: 'data-table-expand' })
      return header
    },

    closePopUp () {
      this.isSuccess = false
      window.location.href = constants.FRONTEND
    },
    approvePlan: async function (isActive) {
      if (this.feeActiveComponent) {
        try {
          this.loadingComponent = this.$buefy.loading.open()
          await http.patch(
            `${constants.API_URL}/api/assign-fee-component/approve`,
            { id: this.feeActiveComponent.id, isActive: isActive }
          )
          this.loadingComponent.close()
          await this.getAllInfo()
          this.$router.push({ name: 'ApproveFeePlan' })
          if (isActive) {
            return this.$buefy.dialog.alert({
              type: 'is-info',
              message: 'Details approved successfully',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } else {
            return this.$buefy.dialog.alert({
              type: 'is-warning',
              message: 'Details Rejected successfully',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message

          console.log('error in fetching data : ', errorMessage)
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } finally {
          this.loadingComponent.close()
        }
      }
    },

    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(
          `${constants.API_URL}/api/student/service/fee-component-fee-installment/${this.planID}`
        )
        this.studentInfo = response.data.studentInfo
        console.log('studentInfo::::', this.studentInfo.franchisee.id)
        console.log(response.data)
        this.feeActiveComponent = response.data.feeActiveComponentJSON
        const feeTypeData = response.data.feeTypes
        this.feeTypeGroup = feeTypeData.feeTypeGroup

        this.isConcession = feeTypeData.isConcession
        this.gstType = feeTypeData.gstType
        this.isIGST = _.isEqual(feeTypeData.gstType, 'IGST')
        this.isGST = feeTypeData.isGST
        this.totalAmount = 0
        this.totalAmountDue = 0
        this.totalConcession = 0
        this.totalAmountToPay = 0
        this.totalAmountToPaid = 0
        this.totalIGST = 0
        this.totalCGST = 0
        this.totalSGST = 0
        this.totalAmountRoyalty = 0
        this.totalAmountDueRoyalty = 0
        this.totalConcessionRoyalty = 0
        this.totalAmountToPayRoyalty = 0
        this.totalAmountPaidRoyalty = 0
        this.totalOtherCollection = 0
        this.totalIGSTRoyalty = 0
        this.totalCGSTRoyalty = 0
        this.totalSGSTRoyalty = 0
        this.totalTDSRoyalty = 0
        this.totalnetAmount = 0
        this.totalRoyaltynetAmount = 0
        this.totalamountDueTillDate = 0
        this.totalamountNonDueTillDate = 0
        _.forEach(this.feeTypeGroup, (item) => {
          item.totalamountDueTillDate = 0
          item.totalamountNonDueTillDate = 0
        })
        _.forEach(this.feeTypeGroup, (item) => {
          _.forEach(item.installments, (obj) => {
            obj.netAmount = this.subTwoNumber(obj.amount, obj.amountConcession)
            obj.netRoyaltyAmount = this.subTwoNumber(
              obj.amountRoyalty,
              obj.amountRoyaltyConcession
            )

            if (
              moment(obj.dueDate).format('YYYY-MM-DD') <=
              moment().format('YYYY-MM-DD')
            ) {
              obj.amountDueTillDate = 0
            } else {
              obj.amountDueTillDate = obj.amountDue
            }
            if (
              moment(obj.dueDate).format('YYYY-MM-DD') >
              moment().format('YYYY-MM-DD')
            ) {
              obj.amountNonDueTillDate = 0
            } else {
              obj.amountNonDueTillDate = obj.amountDue
            }
            item.totalamountDueTillDate = this.addTwoNumber(
              Number(obj.amountDueTillDate),
              Number(item.totalamountDueTillDate)
            )
            item.totalamountNonDueTillDate = this.addTwoNumber(
              Number(obj.amountNonDueTillDate),
              Number(item.totalamountNonDueTillDate)
            )
            obj.amountDue = parseInt(obj.amountDue)
            obj.amountConcession = parseInt(obj.amountConcession)
            if (obj.amountDue <= 0) {
              obj.showConcessionBtn = obj.amountConcession > 0
            } else if (obj.amountDue > 0) {
              obj.showConcessionBtn = true
            }
          })
          this.totalAmount = this.addTwoNumber(
            item.totalAmount,
            this.totalAmount
          )
          this.totalAmountDue = this.addTwoNumber(
            item.totalAmountDue,
            this.totalAmountDue
          )
          this.totalConcession = this.addTwoNumber(
            item.totalConcession,
            this.totalConcession
          )
          this.totalIGST = this.addTwoNumber(item.totalIGST, this.totalIGST)
          this.totalCGST = this.addTwoNumber(item.totalCGST, this.totalCGST)
          this.totalSGST = this.addTwoNumber(item.totalSGST, this.totalSGST)
          this.totalAmountToPay = this.addTwoNumber(
            item.totalAmountPayable,
            this.totalAmountToPay
          )
          this.totalAmountToPaid = this.addTwoNumber(
            item.totalAmountPaid,
            this.totalAmountToPaid
          )
          this.totalAmountRoyalty = this.addTwoNumber(
            item.totalAmountRoyalty,
            this.totalAmountRoyalty
          )
          this.totalAmountDueRoyalty = this.addTwoNumber(
            item.totalAmountDueRoyalty,
            this.totalAmountDueRoyalty
          )
          this.totalConcessionRoyalty = this.addTwoNumber(
            item.totalConcessionRoyalty,
            this.totalConcessionRoyalty
          )
          this.totalIGSTRoyalty = this.addTwoNumber(
            item.totalIGSTRoyalty,
            this.totalIGSTRoyalty
          )
          this.totalCGSTRoyalty = this.addTwoNumber(
            item.totalCGSTRoyalty,
            this.totalCGSTRoyalty
          )
          this.totalSGSTRoyalty = this.addTwoNumber(
            item.totalSGSTRoyalty,
            this.totalSGSTRoyalty
          )
          this.totalTDSRoyalty = this.addTwoNumber(
            item.totalTDSAmtRoyalty,
            this.totalTDSRoyalty
          )

          this.totalAmountToPayRoyalty = this.addTwoNumber(
            item.totalAmountPayableRoyalty,
            this.totalAmountToPayRoyalty
          )
          this.totalAmountPaidRoyalty = this.addTwoNumber(
            item.totalAmountTotalPaidRoyalty,
            this.totalAmountPaidRoyalty
          )
          this.totalOtherCollection = this.addTwoNumber(
            item.totalOtherCollection,
            this.totalOtherCollection
          )

          item.totalnetAmount = this.subTwoNumber(
            item.totalAmount,
            item.totalConcession
          )
          this.totalnetAmount = this.addTwoNumber(
            item.totalnetAmount,
            this.totalnetAmount
          )

          item.totalRoyaltynetAmount = this.subTwoNumber(
            item.totalAmountRoyalty,
            item.totalConcessionRoyalty
          )
          this.totalRoyaltynetAmount = this.addTwoNumber(
            item.totalRoyaltynetAmount,
            this.totalRoyaltynetAmount
          )

          this.totalamountDueTillDate = this.addTwoNumber(
            item.totalamountDueTillDate,
            this.totalamountDueTillDate
          )

          this.totalamountNonDueTillDate = this.addTwoNumber(
            item.totalamountNonDueTillDate,
            this.totalamountNonDueTillDate
          )
        })

        this.headers = this.getHeaders()
        this.headers1 = this.getRoyaltyHeaders()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    subTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) - Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    checkFranchiseeRazorpayAccount: async function () {
      try {
        const Data = await http.get(
          `${constants.API_URL}/api/franchisee/${this.studentInfo.franchisee.id}`
        )
        let getRazorPayAccount = Data.data
        if (!getRazorPayAccount.razorPayAccountID) {
          this.isRazorPayAccount = true
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
